
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaionewaycab() {



    const cardData =
    {
        keyword: ' Pune to Mumbai One Way Cab',
        heading: 'Prince Cabs: Pune to Mumbai One Way Cab',
        headingDescription: 'Prince Cabs offers affordable Pune to Mumbai One Way Cab services, perfect for airport transfers, business trips, family travel, and solo journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride on the Pune–Mumbai Expressway. With professional chauffeurs, transparent one-way fares, and on-time pickups, we provide a smooth and hassle-free travel experience. Choose Prince Cabs’ trusted one way cab service from Pune to Mumbai for reliability, comfort, and value for money.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. It served as a ceremonial entrance to India during the British era. Today, it is surrounded by tourists, photographers, and ferry rides to Elephanta Caves. Sunsets here are breathtaking as the arch glows against the skyline. It is the starting point for exploring South Mumbai."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long promenade along the Arabian Sea. Its streetlights create a necklace-like effect at night, making it a romantic hotspot. Locals and tourists enjoy evening walks, jogging, and sea views here. Monsoon waves crashing against the promenade are dramatic and exciting. Sunsets from Marine Drive are among the best in Mumbai. It represents the city’s vibrant and modern spirit."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and Mumbai’s busiest railway station. Built in 1887, it features Gothic Revival architecture with domes, spires, and stained glass windows. The building looks spectacular when illuminated at night. It is both a transport hub and a historical landmark. Visitors admire its heritage while experiencing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, located on Elephanta Island, are UNESCO World Heritage rock-cut temples. Dating back to the 5th–6th centuries, they showcase remarkable sculptures of Lord Shiva, including the iconic Trimurti. Accessible via ferry from the Gateway of India, the site blends history and spirituality. Surrounded by greenery, it offers a peaceful retreat. The caves highlight India’s ancient art and culture. It is a must-visit for heritage lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, known for its lively atmosphere and street food stalls. Vendors serve Mumbai’s favorite snacks like pav bhaji, bhel puri, and ice gola. Bollywood celebrities often reside nearby, making it a star-spotting zone. Families and tourists gather here in the evenings to enjoy sea breezes. Sunsets at Juhu are stunning and serene. It is the perfect place to experience Mumbai’s coastal charm."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, located in Prabhadevi, is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it attracts thousands of devotees daily, including celebrities and politicians. The temple’s golden dome and intricately carved wooden doors add grandeur. Tuesdays witness heavy pilgrim rush for blessings. Devotees believe that prayers here are always fulfilled. Siddhivinayak is the spiritual heart of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge connecting South Mumbai with the western suburbs. It is an engineering marvel offering stunning views of the Arabian Sea. Driving across the Sea Link is a thrilling experience, especially at night when it is illuminated. It has drastically reduced travel time for commuters. The Sea Link has become a symbol of modern Mumbai. It is one of the city’s most photographed landmarks."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it blends Indo-Islamic architecture. The causeway leading to the dargah is accessible during low tide. Devotees from all faiths visit to seek blessings. Its sea-facing location creates a serene and spiritual atmosphere. Haji Ali is both a sacred and scenic site."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most famous street market, bustling with shops and street vendors. Visitors shop for clothes, jewelry, handicrafts, and antiques at budget-friendly prices. It is also home to iconic cafés like Leopold Café and Café Mondegar. The area is always buzzing with locals and tourists. Bargaining is part of the fun while shopping here. Colaba Causeway reflects Mumbai’s cosmopolitan charm."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a popular beach in South Mumbai, famous for its Ganesh Visarjan celebrations. Families gather here to enjoy local snacks like pav bhaji and kulfi. The beach is lively during evenings with cultural fairs and festivals. It is a great place to relax by the sea after exploring the city. The views of Marine Drive from here are captivating. Girgaon Chowpatty is a blend of leisure and tradition."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the heart of Bollywood filmmaking, spread over 500 acres. It features multiple studios, artificial sets, and shooting zones. Visitors can take guided tours to witness behind-the-scenes of movies and shows. Cinema lovers enjoy spotting live shoots and popular locations. Film City defines Mumbai’s identity as India’s entertainment capital. It is a dream destination for Bollywood fans."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green reserve within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park are the Kanheri Caves, ancient Buddhist rock-cut caves dating back to the 1st century BC. Visitors enjoy safaris, treks, and toy train rides. It is rare to find such biodiversity within a metro city. This destination combines history, nature, and wildlife."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and modern skyscrapers. It is popular for birdwatching, with sightings of herons, kingfishers, and migratory birds. Locals enjoy walking, jogging, and photography along the promenade. The lake looks especially scenic during monsoon with misty views. It is a peaceful retreat in the bustling city. Powai Lake offers calm amidst Mumbai’s chaos."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda, near Gorai, is one of the largest meditation domes in the world. Built in Burmese architectural style, it houses relics of Buddha. The golden dome can accommodate thousands of meditators. Visitors attend meditation sessions and admire its magnificent design. Its serene seaside setting enhances the spiritual atmosphere. It is a global center for peace and mindfulness."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "The Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. It offers immersive sky shows explaining planets, stars, and galaxies. The adjoining Science Centre features interactive exhibits on technology and innovation. Families and students enjoy its educational yet entertaining environment. Special programs are conducted during eclipses and celestial events. It is a must-visit for curious young minds."
  }
],

 "services": [
  {
    "name": "One Way Cab from Pune to Mumbai",
    "description": "Book one way cabs from Pune to Mumbai for convenient and hassle-free travel."
  },
  {
    "name": "Pune to Mumbai One Way Innova",
    "description": "Travel comfortably with Innova one way cab services from Pune to Mumbai."
  },
  {
    "name": "Pune to Mumbai One Way Crysta",
    "description": "Premium one way Crysta cab services from Pune to Mumbai for a smooth and stylish ride."
  },
  {
    "name": "Pune to Mumbai One Way Sedan Cab",
    "description": "Affordable and comfortable sedan cabs available for one way travel from Pune to Mumbai."
  },
  {
    "name": "Pune to Mumbai One Way Taxi Service",
    "description": "Reliable taxi services for one way trips from Pune to Mumbai with professional drivers."
  },
  {
    "name": "Pune to Mumbai One Way Dzire Cab",
    "description": "Economical Dzire cabs for one way travel from Pune to Mumbai, suitable for small groups."
  },
  {
    "name": "Pune to Mumbai One Way SUV Cab",
    "description": "Spacious SUV cabs available for one way journeys from Pune to Mumbai."
  },
  {
    "name": "Pune to Mumbai One Way Cab Price",
    "description": "Transparent pricing for one way cab services between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai One Way Car Rental",
    "description": "Flexible one way car rental options from Pune to Mumbai for your convenience."
  },
  {
    "name": "Affordable One Way Cabs Pune to Mumbai",
    "description": "Budget-friendly one way cab services from Pune to Mumbai without compromising comfort."
  },
  {
    "name": "Pune to Mumbai One Way Ertiga Cab",
    "description": "Comfortable Ertiga cabs for one way travel from Pune to Mumbai, ideal for families."
  },
  {
    "name": "Pune to Mumbai Single Side Taxi",
    "description": "Single side taxi services from Pune to Mumbai for hassle-free one way trips."
  },
  {
    "name": "Pune to Mumbai Drop Taxi",
    "description": "Reliable drop taxi services from Pune to Mumbai ensuring timely and safe journeys."
  },
  {
    "name": "Pune to Mumbai One Side Cab Booking",
    "description": "Easy booking for one side cab services from Pune to Mumbai with professional drivers."
  }
],
"tableData": [
  ["One Way Cab from Pune to Mumbai", "Pune to Mumbai One Way Innova"],
  ["Pune to Mumbai One Way Crysta", "Pune to Mumbai One Way Sedan Cab"],
  ["Pune to Mumbai One Way Taxi Service", "Pune to Mumbai One Way Dzire Cab"],
  ["Pune to Mumbai One Way SUV Cab", "Pune to Mumbai One Way Cab Price"],
  ["Pune to Mumbai One Way Car Rental", "Affordable One Way Cabs Pune to Mumbai"],
  ["Pune to Mumbai One Way Ertiga Cab", "Pune to Mumbai Single Side Taxi"],
  ["Pune to Mumbai Drop Taxi", "Pune to Mumbai One Side Cab Booking"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Mumbai One Way Cab Service",
    "WhyChoosedescription": "Prince Cabs provides dependable one-way cab services from Pune to Mumbai, offering a hassle-free and comfortable journey for business travelers, tourists, and families."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet includes sedans and SUVs such as Swift Dzire and Innova, equipped with air conditioning and ample luggage space to ensure a smooth and relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune to Mumbai Route",
    "WhyChoosedescription": "Our professional drivers have in-depth knowledge of the Pune to Mumbai route, ensuring safe driving, efficient navigation, and timely arrival at your destination."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Suit Your Needs",
    "WhyChoosedescription": "Book your one-way cab easily via phone, WhatsApp, or online platforms with instant confirmation and flexible cancellation policies tailored to your convenience."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing for Pune to Mumbai one-way cabs is competitive and inclusive of fuel, tolls, driver allowances, and taxes, with multiple secure payment methods accepted."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
    "WhyChoosedescription": "All vehicles are cleaned and sanitized before every trip, and undergo regular maintenance, ensuring passenger safety with features like seat belts and airbags."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, changes, and any travel-related queries, ensuring a smooth ride."
  }
]





















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer one-way cab services from Pune to Mumbai?',
        answer: 'Yes, Prince Cabs provides convenient and reliable one-way cab services from Pune to Mumbai, perfect for quick trips and business travel.',
    },
    {
        question: 'What types of vehicles are available for Pune to Mumbai one-way trips?',
        answer: 'We offer a variety of vehicles such as Swift Dzire, Innova, and Tempo Traveller to accommodate solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Pune to Mumbai take by one-way cab?',
        answer: 'The trip usually takes around 3 to 4 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a one-way cab only, without a return trip?',
        answer: 'Absolutely! Prince Cabs specializes in flexible one-way cab bookings without any mandatory return trip requirements.',
    },
    {
        question: 'Are the vehicles clean and sanitized for one-way trips?',
        answer: 'Yes, all our cabs are thoroughly cleaned and sanitized to ensure your health and comfort during the journey.',
    },
    {
        question: 'What are the fares for one-way cab service from Pune to Mumbai?',
        answer: 'Fares vary depending on vehicle type and trip specifics. Please contact Prince Cabs for a customized quote.',
    },
    {
        question: 'How do I book a Pune to Mumbai one-way cab?',
        answer: 'Booking is simple through our website or by calling our customer support team with your travel details.',
    },
];

const testimonials = [
    {
        name: "Mr. Rohit Sharma",
        position: "Business Traveler",
        text: "I booked a one-way cab from Pune to Mumbai with Prince Cabs. The service was punctual and the ride very comfortable.",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-1.png",
    },
    {
        name: "Ms. Neha Joshi",
        position: "Solo Traveler",
        text: "Prince Cabs made my Pune to Mumbai one-way trip hassle-free. The driver was professional and the vehicle was spotless.",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-2.png",
    },
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mumbai One Way Cab",
  "description": "Affordable and reliable one-way cab services from Pune to Mumbai including Innova, Crysta, Sedan, Dzire, SUV, and Ertiga options. Perfect for drop-offs with easy online booking.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "One Way Cab from Pune to Mumbai",
    "Pune to Mumbai One Way Innova",
    "Pune to Mumbai One Way Crysta",
    "Pune to Mumbai One Way Sedan Cab",
    "Pune to Mumbai One Way Taxi Service",
    "Pune to Mumbai One Way Dzire Cab",
    "Pune to Mumbai One Way SUV Cab",
    "Pune to Mumbai One Way Cab Price",
    "Pune to Mumbai One Way Car Rental",
    "Affordable One Way Cabs Pune to Mumbai",
    "Pune to Mumbai One Way Ertiga Cab",
    "Pune to Mumbai Single Side Taxi",
    "Pune to Mumbai Drop Taxi",
    "Pune to Mumbai One Side Cab Booking"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Mumbai One Way Cab | Affordable Innova, Sedan, SUV Taxi</title>
  <meta
    name="description"
    content="Book affordable one-way cabs from Pune to Mumbai with options including Innova, Crysta, Sedan, Dzire, SUV, and Ertiga. Easy online booking for hassle-free travel."
  />
  <meta
    name="keywords"
    content="One Way Cab from Pune to Mumbai, Pune to Mumbai One Way Innova, Pune to Mumbai One Way Crysta, Pune to Mumbai One Way Sedan Cab, Pune to Mumbai One Way Taxi Service, Pune to Mumbai One Way Dzire Cab, Pune to Mumbai One Way SUV Cab, Pune to Mumbai One Way Cab Price, Pune to Mumbai One Way Car Rental, Affordable One Way Cabs Pune to Mumbai, Pune to Mumbai One Way Ertiga Cab, Pune to Mumbai Single Side Taxi, Pune to Mumbai Drop Taxi, Pune to Mumbai One Side Cab Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaionewaycab ;